export default __webpack_public_path__ + "static/media/pictogramBeaconControl48.009ee07c.svg";